import { tryOnScopeDispose as E, noop as h, toValue as w, isObject as g, isClient as k, isIOS as L, notNullish as R } from "./index599.js";
import { computedEager as T, createFilterWrapper as j, debounceFilter as q, computedEager as V, useDebounceFn as $, useTimeoutFn as G } from "./index599.js";
import { computed as A, watch as O, ref as W, getCurrentInstance as C, onMounted as F } from "vue";
function m(o) {
  var r;
  const i = w(o);
  return (r = i?.$el) != null ? r : i;
}
const y = k ? window : void 0;
function b(...o) {
  let r, i, t, p;
  if (typeof o[0] == "string" || Array.isArray(o[0]) ? ([i, t, p] = o, r = y) : [r, i, t, p] = o, !r)
    return h;
  Array.isArray(i) || (i = [i]), Array.isArray(t) || (t = [t]);
  const s = [], d = () => {
    s.forEach((u) => u()), s.length = 0;
  }, a = (u, c, e, n) => (u.addEventListener(c, e, n), () => u.removeEventListener(c, e, n)), f = O(
    () => [m(r), w(p)],
    ([u, c]) => {
      if (d(), !u)
        return;
      const e = g(c) ? { ...c } : c;
      s.push(
        ...i.flatMap((n) => t.map((l) => a(u, n, l, e)))
      );
    },
    { immediate: !0, flush: "post" }
  ), v = () => {
    f(), d();
  };
  return E(v), v;
}
let M = !1;
function _(o, r, i = {}) {
  const { window: t = y, ignore: p = [], capture: s = !0, detectIframe: d = !1 } = i;
  if (!t)
    return h;
  L && !M && (M = !0, Array.from(t.document.body.children).forEach((e) => e.addEventListener("click", h)), t.document.documentElement.addEventListener("click", h));
  let a = !0;
  const f = (e) => p.some((n) => {
    if (typeof n == "string")
      return Array.from(t.document.querySelectorAll(n)).some((l) => l === e.target || e.composedPath().includes(l));
    {
      const l = m(n);
      return l && (e.target === l || e.composedPath().includes(l));
    }
  }), u = [
    b(t, "click", (e) => {
      const n = m(o);
      if (!(!n || n === e.target || e.composedPath().includes(n))) {
        if (e.detail === 0 && (a = !f(e)), !a) {
          a = !0;
          return;
        }
        r(e);
      }
    }, { passive: !0, capture: s }),
    b(t, "pointerdown", (e) => {
      const n = m(o);
      a = !f(e) && !!(n && !e.composedPath().includes(n));
    }, { passive: !0 }),
    d && b(t, "blur", (e) => {
      setTimeout(() => {
        var n;
        const l = m(o);
        ((n = t.document.activeElement) == null ? void 0 : n.tagName) === "IFRAME" && !l?.contains(t.document.activeElement) && r(e);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((e) => e());
}
function I() {
  const o = W(!1), r = C();
  return r && F(() => {
    o.value = !0;
  }, r), o;
}
function S(o) {
  const r = I();
  return A(() => (r.value, !!o()));
}
function x(o, r, i = {}) {
  const { window: t = y, ...p } = i;
  let s;
  const d = S(() => t && "MutationObserver" in t), a = () => {
    s && (s.disconnect(), s = void 0);
  }, f = A(() => {
    const e = w(o), n = (Array.isArray(e) ? e : [e]).map(m).filter(R);
    return new Set(n);
  }), v = O(
    () => f.value,
    (e) => {
      a(), d.value && e.size && (s = new MutationObserver(r), e.forEach((n) => s.observe(n, p)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => s?.takeRecords(), c = () => {
    a(), v();
  };
  return E(c), {
    isSupported: d,
    stop: c,
    takeRecords: u
  };
}
function B(o, r, i = {}) {
  const { window: t = y, ...p } = i;
  let s;
  const d = S(() => t && "ResizeObserver" in t), a = () => {
    s && (s.disconnect(), s = void 0);
  }, f = A(() => Array.isArray(o) ? o.map((c) => m(c)) : [m(o)]), v = O(
    f,
    (c) => {
      if (a(), d.value && t) {
        s = new ResizeObserver(r);
        for (const e of c)
          e && s.observe(e, p);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    a(), v();
  };
  return E(u), {
    isSupported: d,
    stop: u
  };
}
export {
  T as computedEager,
  j as createFilterWrapper,
  q as debounceFilter,
  y as defaultWindow,
  V as eagerComputed,
  k as isClient,
  L as isIOS,
  g as isObject,
  h as noop,
  R as notNullish,
  _ as onClickOutside,
  w as toValue,
  E as tryOnScopeDispose,
  m as unrefElement,
  $ as useDebounceFn,
  b as useEventListener,
  I as useMounted,
  x as useMutationObserver,
  B as useResizeObserver,
  S as useSupported,
  G as useTimeoutFn
};
